// utils/fbPixel.js
export const fbTrack = (event, params = {}) => {
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', event, params);
      console.log(`📦 FB Event Fired: ${event}`, params);
    }
  };
  